var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"id":"video","width":"500px","height":"500px","autoplay":"autoplay"}}),_c('canvas',{attrs:{"id":"canvas","width":"500px","height":"500px"}})])
}]

export { render, staticRenderFns }